<template>
  <div class="timeline">
    <!--타이틀-->
    <div class="header">
      성능운영 타임라인
      <span>최근 24시간 발생정보</span>
      <div>
        <i @click="openTablePopup" class="fas fa-external-link-square-alt"></i>
      </div>
    </div>
    <!--체크박스-->
    <el-checkbox-group v-model="filterTypes" @change="loadData">
      <el-checkbox v-for="button in filterTypeButtonList" :label="button.type" :key="button.type">{{ button.label }}</el-checkbox>
    </el-checkbox-group>
    <!-- <event-options></event-options> -->
    <el-scrollbar style="height: 88%">
      <div class="d-wrapper">
        <div class="details">
          <li v-for="(timeline, index) in timelineList" :key="index" class="normal">
            <div class="status" :style="`background-color: ${getTimelineColor(timeline)}`"></div>
            <div class="time">{{ timeline.timestamp.split('.')[0] }}</div>
            <div class="message c-pointer" @click="onTimelineClick(timeline)">
              <span v-if="timeline.eventDynamicThresholdFlag === 'Y' && timeline.timelineType === 'EVENT'" class="text-red">
                [동적]
              </span>
              <span class="text-blue">{{ timeline.timelineTarget }}</span>
              <div>
                {{ timeline.timelineMessage }}
              </div>
              <div class="event" :style="`background-color: ${getTimelineColor(timeline)}`">{{getEventLevelName(timeline)}}</div>
            </div>
          </li>
        </div>
      </div>
    </el-scrollbar>
    <w-timeline-table-popup ref="timelineTablePopup"></w-timeline-table-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';
import { openFaultAnalysisPopup } from '@/utils/event';
import isEmpty from 'lodash/isEmpty';
import commonAPI from '@/api/performance/common';
import { getDate } from '@/utils/date';
import WTimelineTablePopup from './TimelineTablePopup';

export default {
  name: 'WTimeline',
  components: {
    WTimelineTablePopup,
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      task: 'timelineEvent',
      interval: null,
      timelineList: [],
      filterTypeButtonList: [
        {
          type: 'EVENT',
          label: '이벤트',
        },
        {
          type: 'TROUBLE_TICKET',
          label: '장애티켓',
        },
        {
          type: 'CONFIG_CHANGE',
          label: '구성변경',
        },
        {
          type: 'WORK',
          label: '작업관리',
        },
      ],
      filterTypes: ['EVENT', 'TROUBLE_TICKET', 'CONFIG_CHANGE', 'WORK'],
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
    eventlevelInfo() {
      return this.$store.getters.eventlevelInfo;
    },
  },
  watch: {
    active() {
      if (this.active) {
        this.loadData();
        this.$taskManager.createTask(this.task, 10, this.loadData);
        this.$taskManager.startTask(this.task);
      } else if (this.$taskManager.existTask(this.task)) {
        this.$taskManager.removeTask(this.task);
      }
    },
    selectedNode() {
      if (this.active) {
        this.loadData();
      }
    },
  },
  beforeDestroy() {
    this.$taskManager.removeTask(this.task);
  },
  methods: {
    /**
     * 타임라인 조회
     * @author jeee12
     */
    loadData() {
      commonAPI
        .getTimelineData({
          treeType: this.$store.state.router.treeType,
          timelineTypes: this.filterTypes,
        })
        .then((response) => {
          this.timelineList = response.data.data;
        });
    },
    /**
     * 타임라인 클릭 emit
     * @author leesy918
     * @param  {[type]} timeline [description]
     */
    onTimelineClick(row) {
      if (!isNil(row.objIds)) {
        if (row.timelineType === 'EVENT') {
          openFaultAnalysisPopup(row.timelineTargetId);
        } else {
          this.$store.dispatch('openEventTimelinePopup', row);
        }
      }
    },
    /**
     * 타임라인 테이블 팝업 open
     * @author jeee12
     */
    openTablePopup() {
      this.$refs.timelineTablePopup.open();
    },
    /**
     * 타임라인 색상 반환
     * @author jeee12
     * @param  {[type]} eventlevelId [description]
     */
    getTimelineColor(data) {
      const defaultColor = '#7785aa';
      if (!isEmpty(data.eventlevelId)) {
        const eventInfo = this.eventlevelInfo[data.eventlevelId];
        return !isEmpty(eventInfo) ? eventInfo.eventlevelColorBg : defaultColor;
      }
      return defaultColor; // 로드 시점문제로 인해
    },
    /**
     * 이벤트 등급 아이디에 맞는 이벤트 등급 이름을 반환한다.
     * @author Ju
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getEventLevelName(data) {
      if (!isEmpty(this.eventlevelInfo) || !isNil(data.eventlevelId)) {
        const eventlevel = this.eventlevelInfo[data.eventlevelId];
        return isNil(eventlevel) ? '' : eventlevel.eventlevelName;
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  line-height: 4px;
  color: #999; //$lightgray
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/Timeline.vue